<template>
  <div class="c-plan-table" ref="planTable">
    <!-- <Spin size="large" fix v-if="value"></Spin> -->
    <el-table
      ref="table"
      :height="height"
      row-key="adId"
      class="summary-el-table-styles common-el-table-styles"
      v-loading="value"
      :data="data"
      :summary-method="getSummaries"
      show-summary
      stripe
      border
      row-class-name="h-row"
      @selection-change="select"
      @sort-change="sortChange"
      @header-dragend="headerDragend"
    >
      <el-table-column type="selection" width="39"> </el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :min-width="col.width"
        :sortable="col.sortable"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :formatter="col.format"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'switch'">
            <i-Switch v-model="scope.row.optStatus" :loading="scope.row.optLoading" @on-change="changeActive(scope.row)" size="small" />
            <Button v-if="scope.row.origin" type="primary" size="small" shape="circle">内</Button>
          </div>
          <div v-else-if="col.key === 'adName'">
            <div v-if="scope.row.edit">
              <el-input placeholder="" v-model="scope.row.newadName" style="width: 150px"></el-input>
              <Button type="primary" :loading="saving" size="small" @click="edit(scope.row)">
                <span v-if="!saving">确定</span>
              </Button>
              <Button size="small" @click="cancelEdit(scope.row, 'edit')">取消</Button>
            </div>
            <div v-else>
              <el-button type="text" @click="clickPlan(scope.row)">{{ scope.row.adName }}</el-button>
              <Icon
                v-if="scope.row.mediaId !== 6"
                @click="changEdit(scope.row, 'edit', 'adName')"
                type="md-create"
                class="g-pull-right m-edit"
                size="18"
                color="#409EFF"
              />
            </div>
          </div>
          <div v-else-if="col.key === 'bid'">
            <!-- 头条 -->
            <div v-if="media === 10">
              <div v-if="scope.row.editBid">
                <el-input
                  placeholder=""
                  v-model="scope.row.newbid"
                  style="width: 50px"
                  @blur="inputTrim('newbid', scope.row, true)"
                ></el-input>
                <Button type="primary" :loading="saving" size="small" @click="editBid(scope.row)">
                  <span v-if="!saving">确定</span>
                </Button>
                <Button size="small" @click="cancelEdit(scope.row, 'editBid')">取消</Button>
              </div>
              <div v-else>
                <span>{{ scope.row.bidStatus === 3 ? scope.row.bid2 : scope.row.bid | toThousands }}</span>
                <Icon
                  @click="changEdit(scope.row, 'editBid', 'bid')"
                  type="md-create"
                  class="g-pull-right m-edit"
                  size="18"
                  color="#409EFF"
                />
              </div>
            </div>
            <!-- 腾讯广告/快手 -->
            <div v-if="[16, 32].includes(media)">
              <div v-if="scope.row.editBid">
                <el-input
                  placeholder=""
                  v-model.trim="scope.row.newbid"
                  class="bid-input"
                  style="width: 50px"
                  @blur="inputTrim('newbid', scope.row, true)"
                ></el-input>
                <Button type="primary" :loading="saving" size="small" @click="editBid(scope.row)">
                  <span v-if="!saving">确定</span>
                </Button>
                <Button size="small" @click="cancelEdit(scope.row, 'editBid')">取消</Button>
              </div>
              <div v-else>
                <span>{{ scope.row.bid | toThousands }}</span>
                <Icon
                  v-if="scope.row.bid !== '-'"
                  @click="changEdit(scope.row, 'editBid', 'bid')"
                  type="md-create"
                  class="g-pull-right m-edit"
                  size="18"
                  color="#409EFF"
                />
              </div>
            </div>
            <!-- UC -->
            <div v-if="media === 6">
              <!-- 判断出价状态 -->
              <Row>
                <Col span="18">
                  <p v-if="scope.row.activeBid > 0">激活出价：{{ scope.row.activeBid }}</p>
                  <p v-if="scope.row.payBid > 0">付费出价：{{ scope.row.payBid }}</p>
                  <p v-if="scope.row.roiRatio && scope.row.roiRatio.indexOf('%') > -1">Roi系数：{{ scope.row.roiRatio }}</p>
                </Col>
                <Col span="6">
                  <Icon @click="openBidModifyModal(scope.row)" type="md-create" class="g-pull-right m-edit" size="18" color="#409EFF" />
                </Col>
              </Row>
            </div>
          </div>
          <div v-else-if="col.key === 'bid2'">
            <!-- 快手、百度 -->
            <!-- 20230314显示百度出价 -->
            <template v-if="[32, 45].includes(media)">
              <div v-if="scope.row.editBid2">
                <el-input
                  placeholder=""
                  v-model="scope.row.newbid"
                  style="width: 50px"
                  @blur="inputTrim('newbid', scope.row, true)"
                ></el-input>
                <Button type="primary" :loading="saving" size="small" @click="editKSBid(scope.row)">
                  <span v-if="!saving">确定</span>
                </Button>
                <Button size="small" @click="cancelEdit(scope.row, 'editBid2')">取消</Button>
              </div>
              <div v-else>
                <span>{{ scope.row.bid2 | toThousands }}</span>
                <!-- 20230314显示百度出价，但不显示编辑按钮 -->
                <Icon
                  v-if="scope.row.bid2 !== '-' && media === 32"
                  @click="changEdit(scope.row, 'editBid2', 'bid2')"
                  type="md-create"
                  class="g-pull-right m-edit"
                  size="18"
                  color="#409EFF"
                />
              </div>
            </template>
          </div>
          <div v-else-if="col.key === 'roi'">
            <!-- 快手 -->
            <template v-if="[32, 45].includes(media)">
              <div v-if="scope.row.editROI">
                <el-input
                  placeholder=""
                  v-model="scope.row.newroiRatio"
                  style="width: 50px"
                  @blur="inputTrim('newroiRatio', scope.row, true)"
                ></el-input>
                <Button type="primary" :loading="saving" size="small" @click="editKSBid(scope.row)">
                  <span v-if="!saving">确定</span>
                </Button>
                <Button size="small" @click="cancelEdit(scope.row, 'editROI')">取消</Button>
              </div>
              <div v-else>
                <template v-if="media === 32">
                  <span>{{ scope.row.roiRatio | toThousands }}</span>
                  <Icon
                    v-if="scope.row.roiRatio !== '-'"
                    @click="changEdit(scope.row, 'editROI', 'roiRatio')"
                    type="md-create"
                    class="g-pull-right m-edit"
                    size="18"
                    color="#409EFF"
                  />
                </template>
                <!-- 显示百度roi系数 20230315 -->
                <span v-if="media === 45">{{ scope.row.roiRatioValue }}</span>
              </div>
            </template>
          </div>
          <!-- 预算 -->
          <div v-else-if="col.key === 'budget'">
            <div v-if="scope.row.editBudget">
              <Col span="11">
                <RadioGroup v-model="scope.row.budgetFlag" vertical>
                  <Radio :label="0" :disabled="media === 10"><span>不限</span></Radio>
                  <Radio :label="1">
                    <el-input
                      placeholder=""
                      v-model="scope.row.newbudget"
                      @blur="inputTrim('newbudget', scope.row, true)"
                      :disabled="!scope.row.budgetFlag"
                      style="width: 50px"
                    ></el-input>
                  </Radio>
                </RadioGroup>
              </Col>
              <Col span="13" style="padding-top: 33px">
                <Button type="primary" :loading="saving" size="small" @click="editBudget(scope.row)">
                  <span v-if="!saving">确定</span>
                </Button>
                <Button size="small" @click="cancelEdit(scope.row, 'editBudget')">取消</Button>
              </Col>
            </div>
            <div v-else>
              <span v-if="scope.row.budget > 0">{{ scope.row.budget | toThousands }}</span>
              <span v-else>不限</span>
              <Icon
                @click="changEdit(scope.row, 'editBudget', 'budget')"
                type="md-create"
                class="g-pull-right m-edit"
                size="18"
                color="#409EFF"
              />
            </div>
          </div>
          <div v-else-if="col.key === 'day_budget_schedule'">
            <span>{{ scope.row[col.key] }}</span>
            <Icon type="md-create" class="g-pull-right m-edit" size="18" color="#409EFF" @click="changbudgetModel(scope.row)" />
          </div>
          <div v-else-if="col.key === 'control'">
            <!-- <el-button type="text" size="small" class="m-control-btn" @click="detailClick(scope.row)">详情</el-button> -->
            <el-button type="text" size="small" class="m-control-btn" @click="editClick(scope.row)">修改</el-button>
            <el-button
              type="text"
              size="small"
              class="m-control-btn"
              :disabled="!scope.row.origin || [6, 10, 16, 32, 45].includes(media)"
              @click="copyClick(scope.row)"
              >复制</el-button
            >
            <!-- <span v-if="media === 6"> -->
            <!-- <el-button type="text" size="small" class="m-control-btn" :disabled="media === 6" @click="ideaClick(scope.row, false)">新增</el-button> -->
            <!-- <el-button type="text" size="small" class="m-control-btn" @click="ideaClick(scope.row, true)">修改创意</el-button> -->
            <!-- </span> -->
            <el-button
              type="text"
              size="small"
              class="m-control-btn"
              :disabled="[32, 45].includes(media)"
              @click="ideaClick(scope.row, true)"
              >修改创意</el-button
            >
          </div>
          <el-button type="text" v-else-if="col.key === 'adGroupName'" @click="clickGroup(scope.row)">{{ scope.row[col.key] }}</el-button>
          <span v-else-if="col.key === 'adResourceId'">{{ adResource(scope.row.adResourceId) }}</span>
          <span v-else-if="col.key === 'adResource'">{{ adResource(scope.row.adResource) }}</span>
          <span v-else-if="col.key === 'paperAmount'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'amount'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'pv'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'clickNum'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'clickRate'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="col.key === 'perClickPrice'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thousandsOfDisplayCosts'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'activeNum'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'activeRate'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="col.key === 'convertNum'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'convertRate'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="col.key === 'convertType'">{{ adConvertType(scope.row) }}</span>
          <span v-else-if="col.key === 'status' && scope.row.status !== 4">{{ scope.row.status | adStatus }}</span>
          <el-popover v-else-if="col.key === 'status' && scope.row.status === 4" trigger="hover" placement="top" :width="320">
            <h3 class="m-status-title">审核拒绝理由</h3>
            <p class="m-status-reason">{{ scope.row.auditRejectReason }}</p>
            <span slot="reference" class="m-status-rejust">{{ scope.row.status | adStatus }}</span>
          </el-popover>
          <span v-else-if="col.key === 'bid'">{{ scope.row.bid | adPrice(scope.row) }}</span>
          <span v-else-if="col.key === 'planTime'">{{ scope.row.planTime | adTouTime(scope.row) }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'synTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'autoRuleNameStr'">{{ scope.row[col.key] | autoRule }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <bid-modify v-model="bidModifyModal" :info="planInfo" @on-refresh="$emit('on-refresh')" />
    <betch-budget
      v-model="budgetModel"
      :data="budgets"
      :columns="budgetColumns"
      :type="budgetType"
      :account="budgetAccount"
      :id="budgetId"
      @refresh="$emit('on-refresh')"
    ></betch-budget>
    <betch-error v-model="betchShow" :data="betchErr" :columns="betchColumns" @on-ok="$emit('on-refresh')"></betch-error>
  </div>
</template>
<script>
import mixin from './mixin'
import budgetColumns from '../data/budget.columns'
import { mul, div } from '@/common/js/api'
import { formatDate, setLocalInfo, betweenTime, isEmpty, isArray, trim, getByteLen } from '@/common/js/utils'
import { toThousands } from '@/common/js/filters'
import { editPlanName, batchOperatorPlan, editAdBudget, editPlanBid, getPosition, editKSPlanBid, modifyBudget } from '@/api/convert.model'
import { checkCreative } from '@/api/toutiao.model'
import { hasCreative } from '@/api/uc.model'
import { existCreative } from '@/api/tencent.model'
import { beCreative } from '@/api/baidu.model'
import { ksCreative } from '@/api/kuaishou.model'
import { RES_PATH } from '@/api/config'
import bidModify from '@/components/converter/bid-modify'
import BetchError from '@/components/converter/betch-error.vue'
import BetchBudget from '@/components/converter/batch-budget.vue'

export default {
  name: 'planTable',
  mixins: [mixin],
  components: {
    bidModify,
    BetchError,
    BetchBudget
  },
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    columns: {
      type: Array
    },
    media: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  computed: {
    mediaHtml() {
      let name = ''
      if (this.media === 10) name = 'create/toutiao'
      else if (this.media === 6) name = 'create/uc'
      else if (this.media === 16) name = 'create/tencent'
      else if (this.media === 45) name = 'create/baidu'
      else if (this.media === 32) name = 'create/kuaishou'
      return name
    },
    mediaTitle() {
      let title = []
      if (this.media === 10) title = '投放计划'
      else if (this.media === 6) title = '推广单元'
      else if (this.media === 16) title = '计划'
      else if (this.media === 45) title = '推广单元'
      else if (this.media === 32) title = '计划组'
      return title
    }
  },
  methods: {
    inputTrim(key, row, fixed) {
      let val = parseFloat(row[key])
      if (isEmpty(val) || typeof val !== 'number') {
        this.$set(row, key, 0)
        return
      }
      val = trim(val)
      let fiexdValue = 100
      if (this.media === 32) {
        fiexdValue = 1000
      }
      if (fixed) {
        val = mul(val, fiexdValue)
        val = div(Math.floor(val), fiexdValue)
      } else val = parseInt(val)
      this.$set(row, key, val)
    },
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    // 合计自定义
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      let totalAmount = 0 // 总实际消耗
      let totalRegister = 0 // 总注册数
      let totalPaperAmount = 0 // 总账面消耗
      let totalConverterNum = 0 // 总转化数
      let convertCostIndex // 转化成本索引
      let registerCostIndex // 注册成本索引
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 1) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[prop]))
        if (
          [
            'budget',
            'paperAmount',
            'amount',
            'pv',
            'clickNum',
            'activeNum',
            'convertNum',
            'convertCost',
            'register',
            'registerCost',
            'payCount',
            'payAmount',
            'appCheckoutCount'
          ].includes(prop) &&
          !values.every((value) => isNaN(value))
        ) {
          const sum = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value) && value >= 0) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          // 用于求平均注册、转化成本
          if (column.property === 'amount') totalAmount = sum
          if (column.property === 'register') totalRegister = sum
          if (column.property === 'paperAmount') totalPaperAmount = sum
          if (column.property === 'convertNum') totalConverterNum = sum
          if (prop === 'convertCost') convertCostIndex = index
          if (prop === 'registerCost') registerCostIndex = index
          sums[index] = sum.toString().includes('.') ? toThousands(parseFloat(sum.toFixed(2))) : toThousands(sum)
        } else {
          sums[index] = ''
        }
      })
      sums[convertCostIndex] = totalConverterNum ? parseFloat(totalPaperAmount / totalConverterNum).toFixed(2) : totalPaperAmount.toFixed(2)
      sums[registerCostIndex] = totalRegister ? parseFloat(totalAmount / totalRegister).toFixed(2) : totalRegister
      return sums
    },
    // 修改跳转
    editClick(row) {
      setLocalInfo(row.adAccountId, row.adAccountName, this.$store.state.Convert.media)
      window.open(`/${this.mediaHtml}/plan/${row.adGroupId}?ad=${row.adId}&t=edit`, '_blank')
    },
    // 复制事件
    copyClick(row) {
      if (this.media === 16) {
        this.$emit('on-copy', row)
      } else {
        setLocalInfo(row.adAccountId, row.adAccountName, this.$store.state.Convert.media)
        window.open(`/${this.mediaHtml}/plan/${row.adGroupId}?ad=${row.adId}`, '_blank')
      }
    },
    // 详情跳转
    detailClick(row) {
      const { planId, adName, gameId, gameName, mediaId, mediaName, adAccountId, launchOpName, channelId, sourceId } = row
      const params = {
        planId,
        planName: encodeURIComponent(adName),
        gameId,
        gameName: encodeURIComponent(gameName),
        mediaId,
        mediaName: encodeURIComponent(mediaName),
        adAccountId,
        opName: encodeURIComponent(launchOpName),
        chlId: channelId,
        sourceId,
        beginTime: formatDate(new Date(), 'yyyy-MM-dd'),
        endTime: formatDate(new Date(), 'yyyy-MM-dd'),
        menuId: 20432
      }
      setLocalInfo(row.adAccountId, row.adAccountName, this.$store.state.Convert.media)
      if (!planId) {
        this.$Message.error({
          duration: 5,
          content: '未关联到内部计划'
        })
        return
      }

      getPosition({
        planId: planId
      }).then((data) => {
        let urls = ''
        const query = Object.assign({ advPositionName: encodeURIComponent(data) }, params)
        for (const key in query) {
          if ({}.hasOwnProperty.call(query, key)) {
            if (['planName', 'gameName', 'mediaName', 'opName'].includes(key)) urls += `${key}=${decodeURIComponent(query[key])}&`
            else urls += `${key}=${query[key]}&`
          }
        }
        /* eslint-disable-next-line */
        layer.open({
          type: 2,
          title: `${this.mediaTitle}数据详情概览`,
          content: RES_PATH + '/putonmarket/report/ptomplandatadetails?' + urls,
          area: ['100%', '100%']
        })
      })
    },
    ideaClick(row, status) {
      const { adId, adAccountId, adAccountName, adGroupId, planId } = row
      setLocalInfo(adAccountId, adAccountName, this.$store.state.Convert.media)

      // 需要请求接口验证
      if (status) {
        let callback
        const param = { ad_account_id: adAccountId, ad_id: adId }

        if (this.media === 6) {
          callback = (data) => {
            if (data) {
              const newPage = window.open('about:blank')
              newPage.location.replace(`/${this.mediaHtml}/idea/${adGroupId}/${adId}?plan=${planId}&t=edit`)
            } else {
              this.$Message.error({ duration: 5, content: `该${this.mediaTitle}下没有创意！` })
            }
          }
        } else {
          callback = (data) => {
            const newPage = window.open('about:blank')
            const edit = data ? '&t=edit' : ''
            newPage.location.replace(`/${this.mediaHtml}/idea/${adGroupId}/${adId}?plan=${planId}${edit}`)
          }
        }
        if (adId && adAccountId) {
          this.ideaCheck(param, callback)
        } else this.$Message.error('当前创意ID或账号ID不存在')
      } else {
        window.open(`/${this.mediaHtml}/idea/${adGroupId}/${adId}?plan=${planId}`, '_blank')
      }
    },
    ideaCheck(param, callback) {
      if (this.media === 10) {
        checkCreative(param)
          .then(callback)
          .catch((err) => console.log(err))
      } else if (this.media === 6) {
        hasCreative(param)
          .then(callback)
          .catch((err) => console.log(err))
      } else if (this.media === 16) {
        existCreative(param)
          .then(callback)
          .catch((err) => console.log(err))
      } else if (this.media === 45) {
        beCreative(param)
          .then(callback)
          .catch((err) => console.log(err))
      } else if (this.media === 32) {
        ksCreative(param)
          .then(callback)
          .catch((err) => console.log(err))
      }
    },
    // 改变编辑状态
    changEdit(row, key, feild) {
      let value = row[feild]
      if (feild === 'bid' && row.bidMode === 'OCPM' && row.mediaId !== 32) value = row.bid2
      if (feild === 'bid2') {
        value = row.bid2
        feild = 'bid'
      }
      if (value < 0) value = 0
      this.data.forEach((ret) => {
        this.$set(ret, key, false)
      })
      this.$set(row, `new${feild}`, value)
      this.$set(row, key, true)
    },
    cancelEdit(row, key) {
      this.saving = false
      this.$set(row, key, false)
    },
    openBidModifyModal(row) {
      this.bidModifyModal = true
      this.planInfo = row
    },
    changbudgetModel(row) {
      let budgetSchedule = [{ mon: 0, tue: 0, wed: 0, thur: 0, fri: 0, sat: 0, sun: 0 }]
      const { day_budget_schedule, adAccountId, adId } = row
      if (isArray(day_budget_schedule)) {
        const [mon, tue, wed, thur, fri, sat, sun] = day_budget_schedule
        budgetSchedule = [{ mon, tue, wed, thur, fri, sat, sun }]
      }
      this.budgets = budgetSchedule
      this.budgetModel = true
      this.budgetAccount = adAccountId
      this.budgetId = adId
    },
    // 修改广告组名称
    edit(row) {
      if (this.media === 16 && getByteLen(row.newadName, 3) > 110) {
        this.$Message.error({ duration: 3, content: '计划名称不能超过110个字符' })
        return
      }
      this.saving = true
      editPlanName({
        adAccountId: row.adAccountId,
        adId: row.adId,
        newAdName: row.newadName
      }).then((data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'edit', false)
          this.$emit('on-refresh')
        }
      })
    },
    // 快手修改
    editKSBid(row) {
      let key
      const media = this.$store.state.Convert.media
      if (media === '32') {
        const param = { ad_account_id: row.adAccountId, adId: row.adId }
        const deep_conversion_bid = parseFloat(row.newbid)
        const roi_ratio = parseFloat(row.newroiRatio)
        if (deep_conversion_bid) {
          key = 'editBid2'
          Object.assign(param, { deep_conversion_bid })
        } else if (roi_ratio) {
          key = 'editROI'
          Object.assign(param, { roi_ratio })
        }
        this.saving = true
        editKSPlanBid(param).then((data) => {
          this.saving = false
          if (data) {
            // 修改成功后更新
            this.$set(row, key, false)
            this.$emit('on-refresh')
          }
        })
      }
    },
    // 修改单价
    editBid(row) {
      const bid = parseFloat(row.newbid)
      const bidMode = row.bidMode.toLowerCase()
      const bidStatus = row.bidStatus > 2
      // 验证
      const media = this.$store.state.Convert.media
      if (media === '10') {
        if (row.budget && bid > row.budget) {
          this.$Message.error({ duration: 5, content: '出价不能大于预算值' })
          return
        }
        if (row.bidMode === 'OCPM') {
          if (!(bid >= 0.1 && bid <= 10000)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.1~10000（元）' })
            return
          }
        } else if (row.bidMode === 'CPC') {
          if (!(bid >= 0.2 && bid <= 100)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.2~100（元）' })
            return
          }
        } else if (row.bidMode === 'CPM') {
          if (!(bid >= 4 && bid <= 100)) {
            this.$Message.error({ duration: 5, content: '出价范围：4~100（元）' })
            return
          }
        } else if (row.bidMode === 'CPV') {
          if (!(bid >= 0.07 && bid <= 100)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.07~100（元）' })
            return
          }
        }
      } else if (media === '6') {
        if (row.bidStatus === 1 || row.bidStatus === 2) {
          if (!(bid >= 0.5 && bid < 1000)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.5~1000（元）' })
            return
          }
        } else if (row.bidStatus === 3) {
          if (!(bid >= 1 && bid < 1000)) {
            this.$Message.error({ duration: 5, content: '出价范围：1~1000（元）' })
            return
          }
        }
      } else if (media === '16') {
        if (row.bidMode === 'cpm') {
          if (!(bid >= 1.5 && bid <= 999)) {
            this.$Message.error({ duration: 5, content: '出价范围：1.5~999（元）' })
            return
          }
        } else if (row.bidMode === 'cpc') {
          if (!(bid >= 0.1 && bid <= 100)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.1~100（元）' })
            return
          }
        } else if (row.bidMode === 'ocpa') {
          if (!(bid >= 0.1 && bid <= 2000)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.1~2000（元）' })
            return
          }
        }
      } else if (media === '45') {
        if (bidMode === 'cpm' && !(bid >= 2 && bid <= 9999.99)) {
          this.$Message.error({ duration: 5, content: '出价范围：2~9999.99（元）' })
          return
        } else if (bidStatus && !(bid >= 0.4 && bid <= 999.99)) {
          this.$Message.error({ duration: 5, content: '出价范围：0.4~999.99（元）' })
          return
        } else {
          if (row.inventoryType === '百度联盟媒体' && !(bid >= 0.2 && bid <= 999.99)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.2~999.99（元）' })
            return
          } else if (row.inventoryType !== '百度联盟媒体' && !(bid >= 0.3 && bid <= 999.99)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.3~999.99（元）' })
            return
          }
        }
      }

      this.saving = true
      editPlanBid({
        adAccountId: row.adAccountId,
        adId: row.adId,
        newBid: bid,
        bidMode: row.bidMode.toLowerCase()
      }).then((data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'editBid', false)
          this.$emit('on-refresh')
        }
      })
    },
    // 修改预算
    editBudget(row) {
      const media = this.$store.state.Convert.media
      let budget = parseFloat(row.newbudget)
      let lowBudget // 最低预算
      let totalBudget // 最低总预算

      // 不限
      if (row.budgetFlag) {
        if (media === '10') {
          // 验证
          const day = betweenTime(row.adStartTime, row.adEndTime) || 1 // 投放天数
          if (row.bidMode === 'CPM') {
            lowBudget = 100
            totalBudget = day * lowBudget
          } else {
            lowBudget = 300
            totalBudget = day * lowBudget
          }
          // budgetMode 1 -> 日预算   2 -> 总预算
          if (row.budgetMode === 1 && budget < lowBudget) {
            this.$Message.error({ duration: 5, content: `日预算应大于${lowBudget}元` })
            return
          } else if (row.budgetMode === 2 && budget < totalBudget) {
            this.$Message.error({ duration: 5, content: `总预算应大于${totalBudget}元` })
            return
          }
        } else if (media === '6') {
          const maxBudget = 100000 // 最高日预算

          lowBudget = 100
          if (budget > maxBudget) {
            this.$Message.error({ duration: 5, content: `日预算应小于${maxBudget}元` })
            return
          }
          const activeBid = parseFloat(row.activeBid)
          const payBid = parseFloat(row.payBid)
          if (activeBid && budget <= activeBid) {
            this.$Message.error({ duration: 5, content: '日预算应大于激活出价' })
            return
          }
          if (payBid && budget <= payBid) {
            this.$Message.error({ duration: 5, content: '日预算应大于付费出价' })
            return
          }
        } else if (media === '32') {
          const maxBudget = 100000000 // 最高日预算

          lowBudget = 100
          if (budget > maxBudget) {
            this.$Message.error({ duration: 5, content: `日预算应小于${maxBudget}元` })
            return
          }
        }
      } else {
        if (media === '6') budget = -1
        else budget = 0
      }
      const callback = (data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'editBudget', false)
          this.$emit('on-refresh')
        }
      }
      this.saving = true
      if (media === '32') {
        modifyBudget({ ad_account_id: row.adAccountId, adId: row.adId, day_budget: budget, bizType: 2 }).then(callback)
      } else {
        editAdBudget({ adAccountId: row.adAccountId, adId: row.adId, newAdbudget: budget }).then(callback)
      }
    },
    // 开关
    changeActive(row) {
      let { optStatus } = row
      optStatus = optStatus ? 1 : 0
      if ([1, 0].includes(optStatus)) {
        row.optLoading = true
        this.betch(optStatus, [row])
      }
    },
    select(val) {
      this.selectList = val
    },
    // 批量操作
    changeBetch(type) {
      const len = this.selectList.length
      if (!len) {
        this.$Message.warning({
          duration: 5,
          content: '当前未选中任何计划，请在列表中选择一个或多个计划再进行此操作。'
        })
        return
      }

      // 删除二次验证
      if (type < 0) {
        this.$Modal.confirm({
          title: '提示',
          content: `<p>当前选中${len}条投放计划，确定删除吗？</p>`,
          onOk: () => {
            this.betch(type, this.selectList)
          }
        })
      } else {
        const seleIds = this.selectList.map((ret) => ret.planId)
        this.data.forEach((ret) => {
          this.$set(ret, 'optLoading', seleIds.includes(ret.planId))
        })
        this.betch(type, this.selectList)
      }
    },
    betch(type, row) {
      batchOperatorPlan({
        type,
        adIds: row
      }).then((data) => {
        if (data) {
          const { failNum, rows } = data
          if (failNum && row.length > 1) {
            // 显示错误列表
            this.betchErr = rows
            this.betchShow = true
            this.data.forEach((ret) => {
              this.$set(ret, 'optLoading', false)
            })
            return
          } else if (failNum && row.length === 1) {
            this.$Message.error({
              duration: 5,
              content: rows[0].result
            })
            this.$set(row, 'optStatus', type === 0)
            this.$set(row, 'optLoading', false)
          } else {
            this.$Message.success({
              duration: 5,
              content: '操作成功'
            })
          }
          this.$emit('on-refresh')
        }
      })
    },
    clickGroup(row) {
      const { adGroupId, adGroupName, adAccountId } = row
      if (this.media === 6) {
        this.$router.push({
          name: 'plan',
          query: {
            id: adGroupId,
            adAccountId: adAccountId
          }
        })
      } else {
        this.$store.commit('setIndexRoute', 'group')
        this.$router.push({
          name: 'advert',
          query: {
            media: this.media,
            id: adGroupId,
            name: encodeURI(adGroupName)
          }
        })
      }
    },
    clickPlan(row) {
      const { adGroupId, adGroupName, adId, adName, adAccountId } = row
      if (this.media === 6) {
        this.$router.push({
          name: 'idea',
          query: {
            id: adGroupId,
            adAccountId: adAccountId,
            adId
          }
        })
      } else {
        this.$store.commit('setIndexRoute', 'plan')
        this.$router.push({
          name: 'creative',
          query: {
            id: adGroupId,
            name: encodeURI(adGroupName),
            adId,
            adName: encodeURI(adName)
          }
        })
      }
    },
    headerDragend(n, o, column) {
      this.$emit('header-dragend', { n, o, column })
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  },
  filters: {
    adPrice: (cellValue, row) => {
      let bid = cellValue
      if (row.bidMode.toLowerCase() === 'ocpm') bid = row.bid2
      return bid
    },
    autoRule: (cellValue, row) => {
      let val = cellValue
      if (val === null) val = '-'
      return val
    }
  },
  data() {
    return {
      saving: null, // 修改请求状态
      selectList: [], // 选中
      betchErr: [], // 批量错误
      betchShow: false, // 批量错误弹窗
      betchColumns: [],
      budgetModel: null,
      budgetId: '',
      budgetType: 2,
      budgetAccount: 0,
      budgetColumns: [],
      budgets: [],
      bidModifyModal: false,
      planInfo: {}
    }
  },
  created() {
    const s_max = 100
    this.budgetColumns = budgetColumns.map((ret) => {
      ret.render = (h, params) => {
        return h('InputNumber', {
          props: {
            step: 100,
            value: params.row[ret.key],
            min: s_max,
            max: 100000000
          },
          on: {
            'on-change': (event) => {
              this.budgets[params.index][ret.key] = event
            },
            'on-blur': () => {
              const event = params.row[ret.key]
              if (event && event < s_max) {
                this.$Message.warning(`分日预算最小值为 ${s_max}`)
                this.budgets[params.index][ret.key] = s_max
              } else if (event && event > 100000000) {
                this.$Message.warning('分日预算最大值为 100000000')
                this.budgets[params.index][ret.key] = 100000000
              }
            }
          },
          style: {
            width: '68px'
          }
        })
      }
      return ret
    })
  },
  mounted() {
    this.betchColumns = [
      {
        key: 'mediaName',
        title: '媒体名称',
        tooltip: true,
        minWidth: 100
      },
      {
        key: 'adName',
        title: `${this.mediaTitle}名称`,
        tooltip: true,
        minWidth: 140
      },
      {
        key: 'result',
        title: '结果',
        tooltip: true,
        minWidth: 250
      }
    ]
  }
}
</script>
<style lang="scss" scoped>
.c-plan-table {
  position: relative;
  background-color: #fff;

  .el-table {
    .m-control-btn {
      margin: 0;
      padding: 0 3px;
    }

    .m-disable-btn {
      color: #989898;
      cursor: not-allowed;
    }

    .h-row:hover {
      .m-edit {
        visibility: visible;
      }
    }

    ::v-deep .m-edit {
      visibility: hidden;
    }
  }

  .m-status-rejust {
    color: #ff6600;
  }
}

::v-deep .bid-input {
  input {
    padding: 0;
  }
}

.m-status-title {
  font-size: 14px;
  text-align: center;
  color: #333;
  margin-bottom: 8px;
}

.m-status-reason {
  line-height: 22px;
  font-size: 12px;
  color: #666;
}

::v-deep dl.bid-custom-dl {
  dd,
  dt {
    display: inline-block;
  }
}
</style>
